module.exports = __webpack_public_path__ + "assets/img/media-usa-news.59c0f218.svg";